import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הפחד",
    opening: localizedGenderNode(
      [
      "היום אני לא נאבק/ת בפחד.",
      "אני רק שם/ה לב: הוא כאן."
    ],
      [
      "היום אני לא נאבק/ת בפחד.",
      "אני רק שם/ה לב: הוא כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מתי הפחד הזה הכי חזק?",
      "אני שואל/ת את עצמי, בשקט: על מה הראש שלי רץ מיד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מרגיש/ה בגוף?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מתי הפחד הזה הכי חזק?",
      "אני שואל/ת את עצמי, בשקט: על מה הראש שלי רץ מיד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מרגיש/ה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד הוא חוויה, לא נבואה."
    ],
      [
      "פחד הוא חוויה, לא נבואה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני רואה את הפחד\".",
      "נשימה אחת + \"אני רואה את הפחד\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו זה מתחיל.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני שם/ה לב לרגע שבו זה מתחיל.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה קורה ממש לפני שזה עולה?",
      "אני שואל/ת את עצמי, בשקט: איפה זה פוגש אותי ביום?",
      "אני שואל/ת את עצמי, בשקט: ממה אני מפחד/ת שיקרה?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה קורה ממש לפני שזה עולה?",
      "אני שואל/ת את עצמי, בשקט: איפה זה פוגש אותי ביום?",
      "אני שואל/ת את עצמי, בשקט: ממה אני מפחד/ת שיקרה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מעט מרחב."
    ],
      [
      "ברגע הראשון יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשזה מתחיל.",
      "נשימה אחת כשזה מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "סימני הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איפה הגוף מרגיש את הפחד?",
      "אני שואל/ת את עצמי, בשקט: מה הגוף שלי מנסה להגן?",
      "אני שואל/ת את עצמי, בשקט: מה יכול להתרכך קצת?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איפה הגוף מרגיש את הפחד?",
      "אני שואל/ת את עצמי, בשקט: מה הגוף שלי מנסה להגן?",
      "אני שואל/ת את עצמי, בשקט: מה יכול להתרכך קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף שלי מנסה לשמור עליי."
    ],
      [
      "הגוף שלי מנסה לשמור עליי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה העובדה הפשוטה כאן?",
      "אני שואל/ת את עצמי, בשקט: איזה סיפור קפץ לי?",
      "אני שואל/ת את עצמי, בשקט: איזו אפשרות רכה יכולה להיות נכונה גם היא?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה העובדה הפשוטה כאן?",
      "אני שואל/ת את עצמי, בשקט: איזה סיפור קפץ לי?",
      "אני שואל/ת את עצמי, בשקט: איזו אפשרות רכה יכולה להיות נכונה גם היא?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה מפעיל",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מדליק את הפחד.",
      "לא כדי להימנע."
    ],
      [
      "היום אני מזהה מה מדליק את הפחד.",
      "לא כדי להימנע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה בדרך כלל מדליק את הפחד?",
      "אני שואל/ת את עצמי, בשקט: איזה סימן קטן אני שם/ה לב אליו?",
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה ברגע הזה?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה בדרך כלל מדליק את הפחד?",
      "אני שואל/ת את עצמי, בשקט: איזה סימן קטן אני שם/ה לב אליו?",
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לזהות טריגר זו התחלה של בחירה."
    ],
      [
      "לזהות טריגר זו התחלה של בחירה."
    ]
    ),
    action: localizedGenderNode(
      "לתת שם לטריגר אחד.",
      "לתת שם לטריגר אחד."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קולות פנימיים",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לקול שמגביר את הפחד.",
      "אני לא מתווכח/ת איתו."
    ],
      [
      "היום אני שם/ה לב לקול שמגביר את הפחד.",
      "אני לא מתווכח/ת איתו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרפה את הכתפיים מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרפה את הכתפיים מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איזה משפט מפחיד חוזר בי?",
      "אני שואל/ת את עצמי, בשקט: מה המשפט הזה מנסה לעשות?",
      "אני שואל/ת את עצמי, בשקט: מה הקול השקט שלי אומר?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איזה משפט מפחיד חוזר בי?",
      "אני שואל/ת את עצמי, בשקט: מה המשפט הזה מנסה לעשות?",
      "אני שואל/ת את עצמי, בשקט: מה הקול השקט שלי אומר?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לבחור איזה קול להחזיק."
    ],
      [
      "אני יכול/ה לבחור איזה קול להחזיק."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי אחד רך.",
      "משפט פנימי אחד רך."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "צורך בביטחון",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך שמתחת לפחד.",
      "אני לא פותר/ת."
    ],
      [
      "היום אני נוגע/ת בצורך שמתחת לפחד.",
      "אני לא פותר/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ],
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה כדי להרגיש בטוח/ה יותר?",
      "אני שואל/ת את עצמי, בשקט: מה בי מבקש חום או קרבה?",
      "אני שואל/ת את עצמי, בשקט: איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה כדי להרגיש בטוח/ה יותר?",
      "אני שואל/ת את עצמי, בשקט: מה בי מבקש חום או קרבה?",
      "אני שואל/ת את עצמי, בשקט: איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מאחורי פחד יש בקשה."
    ],
      [
      "מאחורי פחד יש בקשה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת לעצמי.",
      "לכתוב בקשה אחת לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חיבור קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי."
    ],
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה נותן לי תחושת חיבור עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איזו מילה מרגיעה אותי?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לתת לעצמי לרגע?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה נותן לי תחושת חיבור עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איזו מילה מרגיעה אותי?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לתת לעצמי לרגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חיבור קטן גם הוא חיבור."
    ],
      [
      "חיבור קטן גם הוא חיבור."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שקטה בלב.",
      "מילה אחת שקטה בלב."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "חמלה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מדבר/ת עם עצמי בעדינות.",
      "לא כמו שופט/ת."
    ],
      [
      "היום אני מדבר/ת עם עצמי בעדינות.",
      "לא כמו שופט/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איך הייתי מדבר/ת לחבר/ה במקום הזה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לסלוח לעצמי עליו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איך הייתי מדבר/ת לחבר/ה במקום הזה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לסלוח לעצמי עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עדינות לא מבטלת את הפחד."
    ],
      [
      "עדינות לא מבטלת את הפחד."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הבטן נרגעת מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הבטן נרגעת מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה הבקשה הכי חשובה שלי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך לומר אותה במשפט אחד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה הבקשה הכי חשובה שלי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך לומר אותה במשפט אחד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה להרגיע."
    ],
      [
      "בקשה אחת יכולה להרגיע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך מול פחד",
    opening: localizedGenderNode(
      [
      "היום אני מזכיר/ה לעצמי מה חשוב לי.",
      "לא כדי לבטל את הפחד."
    ],
      [
      "היום אני מזכיר/ה לעצמי מה חשוב לי.",
      "לא כדי לבטל את הפחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לפנים רגועות.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לפנים רגועות.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איזה ערך חשוב לי מול הפחד הזה?",
      "אני שואל/ת את עצמי, בשקט: איך הערך הזה נראה ביום רגיל?",
      "אני שואל/ת את עצמי, בשקט: מה צעד פנימי קטן שמכבד אותו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איזה ערך חשוב לי מול הפחד הזה?",
      "אני שואל/ת את עצמי, בשקט: איך הערך הזה נראה ביום רגיל?",
      "אני שואל/ת את עצמי, בשקט: מה צעד פנימי קטן שמכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך נותן לי כיוון."
    ],
      [
      "ערך נותן לי כיוון."
    ]
    ),
    action: localizedGenderNode(
      "לבחור ערך אחד ולחזור עליו בלב.",
      "לבחור ערך אחד ולחזור עליו בלב."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "איך אני עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך אני מתייחס/ת לעצמי.",
      "אני לא שופט/ת."
    ],
      [
      "היום אני בודק/ת איך אני מתייחס/ת לעצמי.",
      "אני לא שופט/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לעצמי חצי דקה של שקט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לעצמי חצי דקה של שקט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: באיזה רגע אני נלחץ/ת מעצמי?",
      "אני שואל/ת את עצמי, בשקט: איפה אני יכול/ה להרפות קצת?",
      "אני שואל/ת את עצמי, בשקט: איך אני רוצה לדבר עם עצמי בעתיד?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: באיזה רגע אני נלחץ/ת מעצמי?",
      "אני שואל/ת את עצמי, בשקט: איפה אני יכול/ה להרפות קצת?",
      "אני שואל/ת את עצמי, בשקט: איך אני רוצה לדבר עם עצמי בעתיד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "איך שאני איתי חשוב כמו כל דבר."
    ],
      [
      "איך שאני איתי חשוב כמו כל דבר."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של כבוד לעצמי.",
      "משפט אחד של כבוד לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן שאפשר להחזיק.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת שינוי קטן שאפשר להחזיק.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגוף יציב לרגע.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגוף יציב לרגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה שינוי קטן יכול לעזור לי היום?",
      "אני שואל/ת את עצמי, בשקט: איך זה ייראה בפועל?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לנסות פעם אחת?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה שינוי קטן יכול לעזור לי היום?",
      "אני שואל/ת את עצמי, בשקט: איך זה ייראה בפועל?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לנסות פעם אחת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק זה מספיק."
    ],
      [
      "קטן מספיק זה מספיק."
    ]
    ),
    action: localizedGenderNode(
      "צעד אחד קטן לעצמי.",
      "צעד אחד קטן לעצמי."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת ברוך.",
      "אני בוחר/ת משפט שמחזיר אותי."
    ],
      [
      "היום אני מסיים/ת ברוך.",
      "אני בוחר/ת משפט שמחזיר אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה אוויר נכנס ויוצא.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה אוויר נכנס ויוצא.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה למדתי על הפחד הזה?",
      "אני שואל/ת את עצמי, בשקט: מה הסימן המוקדם שהוא עולה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט מחזיר אותי לרגע לפני?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה למדתי על הפחד הזה?",
      "אני שואל/ת את עצמי, בשקט: מה הסימן המוקדם שהוא עולה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט מחזיר אותי לרגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ],
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת ומשפט החזרה שלי.",
      "נשימה אחת ומשפט החזרה שלי."
    ),
  },
].map(buildNormalizedDay);

export const fearOfIllnessDeathBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_of_illness_death_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_of_illness_death",
  category: "anxiety",
  journeyName: {
    he: "פחד מחולי / מוות",
    en: "Fear of illness / death",
    es: "Miedo a la enfermedad / muerte",
  },
  days,
});

export default fearOfIllnessDeathBlueprintHe;
